import { render, staticRenderFns } from "./RemainingLeavesPrint.vue?vue&type=template&id=5d50e46a&scoped=true&"
import script from "./RemainingLeavesPrint.vue?vue&type=script&lang=js&"
export * from "./RemainingLeavesPrint.vue?vue&type=script&lang=js&"
import style0 from "./RemainingLeavesPrint.vue?vue&type=style&index=0&id=5d50e46a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d50e46a",
  null
  
)

export default component.exports